import React from "react";

import Backdrop from "../Backdrop/Backdrop";
import UILoader from "./Loader";

const UISoleraLoader = ({ open }) =>
  open ? (
    <Backdrop>
      <UILoader />
    </Backdrop>
  ) : null;

export default UISoleraLoader;
